.g1{z-index:2;}